import type { FilterTopic } from '../../FilterMenu/types';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import type { FC } from 'react';

const FilterMenuComponent = dynamic(
  () => import('components/FilterMenu').then((m: any) => m.FilterMenu),
  {
    ssr: true,
  },
) as any;

type FilterMenuProps = {
  isOpen: boolean;
  onClose: () => void;
  totalSearchResult: number;
  availableFilters: FilterTopic[];
  searchItemLabels: Record<string, string>;
  onApplyFilters: (filters: string[][]) => void;
  currentSearchCategory: string;
  query: string;
};

const FilterMenu: FC<FilterMenuProps> = ({
  isOpen,
  onClose,
  totalSearchResult,
  availableFilters,
  searchItemLabels,
  onApplyFilters,
  currentSearchCategory,
  query,
}) => {
  const router = useRouter();

  const applyFilters = (newFilters: FilterTopic[]): void => {
    const selectedFacets: string[][] = newFilters.map((nf) =>
      nf.options.reduce(
        (topicResults, option) => (option.selected ? [...topicResults, option.key] : topicResults),
        [] as string[],
      ),
    );
    const filters = selectedFacets.reduce(
      (facets: string[][], current: string[]) => (!current.length ? facets : [...facets, current]),
      [] as string[][],
    );

    onApplyFilters(filters);

    const queryFilters = filters
      .map((filter) => filter.join(','))
      .reduce(
        (accFilter: string, currentFilter: string) =>
          `${accFilter ? `${accFilter},` : ''}${currentFilter}`,
        '',
      );
    const queryString = `?category=${encodeURIComponent(currentSearchCategory)}${
      query ? `&query=${encodeURIComponent(query)}` : ''
    }${queryFilters.length ? `&filters=${encodeURIComponent(queryFilters)}` : ''}`;
    router.push(queryString);
  };
  return (
    <FilterMenuComponent
      id="search-filter-menu"
      isOpen={isOpen}
      totalResults={totalSearchResult}
      title={searchItemLabels?.filters}
      onClose={onClose}
      onApplyFilters={(newFilters: FilterTopic[]) => applyFilters(newFilters)}
      filters={availableFilters}
      labels={searchItemLabels}
    />
  );
};

export default FilterMenu;
